/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
const emptyWidgetWithVisType = (visTypeId) => {
	return {
		model: {
			type: 'live',
			visId: visTypeId,
			visTypeLocked: true,
			data: {}
		}
	};
};

/**
 * @param {Object} dashboardApi
 * @param {String} widgetId - ID of the widget
 * @return {Object} - the internal widget model object or null when not found
 */
const getWidgetSpec = (dashboardApi, widgetId) => {
	const canvas = dashboardApi.getFeature('Canvas');
	if (canvas) {
		const widgetContent = canvas.getContent(widgetId);
		if (widgetContent) {
			return widgetContent.getFeature('Models.internal').getWidgetModel().toJSON();
		}
	}
	return null;
};

/**
 * @param {Object} card
 * @param {Object} dashboardApi
 * @return {object} a promise which is resolved with new spec for given card without id, titleHtml and thumbnailId props
 */
const getWidgetSpecForCompareCard = (card, dashboardApi) => {
	let widgetSpec = null;
	let widgetModel = null;
	if (card && card.items.length) {
		const widgetId = card.items[0].id;
		widgetModel = getWidgetSpec(dashboardApi, widgetId);
		if (widgetModel) {
			delete widgetModel.id;
			delete widgetModel.titleHtml;
			delete widgetModel.thumbnailId;
			widgetSpec = {
				model: widgetModel,
				specType: 'widget'
			};
			const extraWidgetOptions = {
				properties: [{
					id: 'itemAxis.labels.layoutMode',
					value: 'stagger'
				}, {
					id: 'widget.legend.position',
					value: 'right'
				}]
			};
			Object.assign(widgetSpec.model, extraWidgetOptions);
		}
	}
	return Promise.resolve(widgetSpec);
};

export default {
	getWidgetSpec,
	emptyWidgetWithVisType,
	getWidgetSpecForCompareCard
};



// WEBPACK FOOTER //
// ./src/js/core/WidgetSpecUtil.js